'use client';
import React from 'react';
import Image from 'next/image';
import styles from '../header.module.css';
import LogoPath from '@root/src/assets/images/logolytra-transparent.png';

const Logo = () => {
  return (
    <div className={`${styles.logo} bg-transparent`}>
      <Image
        src={LogoPath}
        alt="Ly Trà"
        priority
        sizes="(max-width: 640px) 96px, (max-width: 1024px) 128px, 160px"
        className="h-10 w-auto object-contain bg-transparent sm:h-12 md:h-16 lg:h-24"
      />
    </div>
  );
};

export default Logo;
